import { TagProps } from 'bold-ui'
import { Color } from 'csstype'
import { Ciap, Cid10, SubtipoAtendimentoHistoricoClinico, TipoRegistroHistoricoClinico } from 'graphql/types.generated'
import {
  accordionBloqueadoMensagem,
  EscutaHistoricoTagModel,
  HistoricoDetalhesModel,
} from 'view/atendimentos/detail/historico/model/model-historico'

export interface FolhaRostoTagModel extends TagProps {
  label: string
}

export interface FolhaRostoUltimosContatosModel {
  id: ID
  tipo: TipoRegistroHistoricoClinico
  title: string
  color: Color
  barColor: Color
  icon: React.ReactElement
  dataOrTurno: string
  dadosClinicos?: string
  examesRealizadosZika?: string[]
  headerTags?: FolhaRostoTagModel[]
  classificacaoRisco?: EscutaHistoricoTagModel
  contentTags?: FolhaRostoTagModel[]
  idadeGestacional?: { dias: number; semanas: number }
  historicoAtendimento: HistoricoDetalhesModel
  hasObservacao: boolean
  isCuidadoCompartilhado: boolean
  cid10?: Cid10
  ciap?: Ciap
}

export const VisitaAusenteOuRecusadaRecord: Record<string, string> = {
  'Cidadão ausente': `${
    accordionBloqueadoMensagem[SubtipoAtendimentoHistoricoClinico.CIDADAO_AUSENTE]
  } no momento da visita. Não há detalhes a serem exibidos`,
  'Visita recusada': `${
    accordionBloqueadoMensagem[SubtipoAtendimentoHistoricoClinico.VISITA_RECUSADA]
  } no momento da visita. Não há detalhes a serem exibidos`,
}
